"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var ShopifyCart = /** @class */ (function () {
    function ShopifyCart() {
    }
    ShopifyCart.lineItemPropertyKey = "_click_and_collect_location";
    ShopifyCart.LocationUpdate = function (locationId, locationName, lineItemPropertyKey) {
        if (lineItemPropertyKey === void 0) { lineItemPropertyKey = ShopifyCart.lineItemPropertyKey; }
        return __awaiter(_this, void 0, void 0, function () {
            var lineItems, _i, lineItems_1, lineItem;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, fetch("/cart/update.js", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                                attributes: (_a = {
                                        _click_and_collect: true
                                    },
                                    _a[lineItemPropertyKey + "_id"] = locationId,
                                    _a[lineItemPropertyKey + "_name"] = locationName,
                                    _a),
                            }),
                        })];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, ShopifyCart.LineItemsRead()];
                    case 2:
                        lineItems = _b.sent();
                        return [4 /*yield*/, ShopifyCart.LineItemsClear()];
                    case 3:
                        _b.sent();
                        _i = 0, lineItems_1 = lineItems;
                        _b.label = 4;
                    case 4:
                        if (!(_i < lineItems_1.length)) return [3 /*break*/, 7];
                        lineItem = lineItems_1[_i];
                        return [4 /*yield*/, ShopifyCart.LineItemsAdd(__assign({}, lineItem, { properties: __assign({}, lineItem.properties, { _click_and_collect: true }) }))];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6:
                        _i++;
                        return [3 /*break*/, 4];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    ShopifyCart.LocationRemove = function (lineItemPropertyKey) {
        if (lineItemPropertyKey === void 0) { lineItemPropertyKey = ShopifyCart.lineItemPropertyKey; }
        return __awaiter(_this, void 0, void 0, function () {
            var lineItems, _i, lineItems_2, lineItem;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, fetch("/cart/update.js", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                                attributes: (_a = {
                                        _click_and_collect: null
                                    },
                                    _a[lineItemPropertyKey + "_id"] = null,
                                    _a[lineItemPropertyKey + "_name"] = null,
                                    _a),
                            }),
                        })];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, ShopifyCart.LineItemsRead()];
                    case 2:
                        lineItems = _b.sent();
                        return [4 /*yield*/, ShopifyCart.LineItemsClear()];
                    case 3:
                        _b.sent();
                        _i = 0, lineItems_2 = lineItems;
                        _b.label = 4;
                    case 4:
                        if (!(_i < lineItems_2.length)) return [3 /*break*/, 7];
                        lineItem = lineItems_2[_i];
                        return [4 /*yield*/, ShopifyCart.LineItemsAdd(__assign({}, lineItem, { properties: __assign({}, lineItem.properties, { _click_and_collect: false }) }))];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6:
                        _i++;
                        return [3 /*break*/, 4];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    ShopifyCart.LineItemsAdd = function (options, lineItemPropertyKey) {
        if (lineItemPropertyKey === void 0) { lineItemPropertyKey = ShopifyCart.lineItemPropertyKey; }
        return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch("/cart/add.js", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                id: options.id,
                                quantity: options.quantity,
                                properties: __assign({ _click_and_collect: true }, options.properties),
                            }),
                        })];
                    case 1:
                        _a.sent();
                        if (!(options.locationId && options.locationName)) return [3 /*break*/, 3];
                        return [4 /*yield*/, ShopifyCart.LocationUpdate(options.locationId, options.locationName, lineItemPropertyKey)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ShopifyCart.LineItemsRead = function () { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("/cart.js")
                        .then(function (response) { return response.json(); })
                        .catch(function (error) { return ({ items: [] }); })];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result.items];
            }
        });
    }); };
    ShopifyCart.LineItemsClear = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("/cart/clear.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({}),
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return ShopifyCart;
}());
exports.ShopifyCart = ShopifyCart;
//# sourceMappingURL=shopify-cart.js.map